import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'loader',
    template: `
    <div class="t-inputWrap-loader" role="alert"></div>
  `,
    standalone: false
} )
export class LoaderComponent implements OnInit {

  constructor() {}

  ngOnInit() {
  }

}
